module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/carousel/carousel-edit/carousel-edit.component.scss
// module id = ./src/app/carousel/carousel-edit/carousel-edit.component.scss
// module chunks = main